import { render } from "./ReceiptSearch.vue?vue&type=template&id=0cfe3098"
import script from "./ReceiptSearch.vue?vue&type=script&lang=js"
export * from "./ReceiptSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__